<script>
export default {
  props: {
    text: {
      type: Boolean,
      default: false,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'success',
      validator: function(value) {
        return (
          [
            'success',
            'warning',
            'danger',
            'info',
            'semi-success-warning',
            'finish',
          ].indexOf(value) !== -1
        )
      },
    },
  },
}
</script>

<template>
  <span
    :class="[$style.label, $style[`label--${state}`], { [$style['label--text']]: text,
   [$style['label--dot']]: dot }]"
  >
    <slot></slot>
  </span>
</template>

<style lang="scss" module>
@import '@design';

$type-state-map: (
  success: $color-state-success,
  danger: $color-state-danger,
  info: $color-state-info,
  warning: $color-state-warning,
  semi-success-warning:
    linear-gradient($color-state-success 50%, $color-state-warning 50%),
  finish: $color-state-finish
);

.label {
  box-sizing: border-box;
  display: inline-block;
  font-weight: bold;
  letter-spacing: $font-letter-spacing-small;
  white-space: nowrap;

  & + & {
    margin-left: 10px;
  }

  @each $state, $color in $type-state-map {
    &--#{$state} {
      color: white;
      background: $color;
      &.label--text {
        color: $color;
        background: transparent;
      }
      &.label--dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      &:not(.label--text):not(.label--dot) {
        height: 25px;
        padding: 0 18px;
        font-size: $font-size-smaller;
        line-height: 25px;
      }
    }
  }
}
</style>
